/// <reference path="../types.d.ts" />

import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from '../core/net';
import { putContext } from './contexts.action';
import { loading } from './ui-core.actions';
import { navigateContext } from './navigation.actions';
import { cmxLocation, HttpMethods, commonActions } from '@codametrix/ui-common';
import { saveEula } from './eula-shared.actions';
const { Eula } = commonActions;

const cancelEula = createAction(
  Eula.CANCEL_EULA,
  (value: boolean) => ({ payload: value, meta: { analytics: true } })
);

const acceptInitial = createAction(
  Eula.ACCEPT_INIT,
  (value: CMxAPI.Eula) => ({ payload: value, meta: { analytics: true } })
);

type AcceptEulaPayload = {
  eula: CMxAPI.Eula;
  context: CMx.Context;
  homepagePreference?: CMxAPI.Preference;
};
const acceptEula = createAsyncThunk(Eula.ACCEPT_EULA, async (
  payload: AcceptEulaPayload,
  {
    dispatch,
    getState,
    rejectWithValue
  }
): Promise<CMxAPI.User> => {
  dispatch(acceptInitial(payload.eula));
  const user = await api<CMxAPI.User>({
    endpoint: '/users/eula/v1',
    init: {
      method: HttpMethods.POST
    },
    body: payload.eula
  });
  dispatch(saveEula(payload.eula));

  if (payload.context.activeContext?.organizationId) {
    const freshContext = await putContext(
      {
        organizationId: payload.context.activeContext?.organizationId.toString()
      },
      dispatch
    );
    cmxLocation.resetLocation();
    dispatch(loading(false));
    await dispatch(
      navigateContext({
        context: freshContext,
        homepagePreference: payload.homepagePreference
      })
    );
  } else {
    cmxLocation.resetLocation();
  }

  return user;
});

export { saveEula, acceptEula, cancelEula };
export { getEula } from './eula-shared.actions';
